import React from 'react';
import moment from 'moment';
import XLSX from 'xlsx';
import BaseClass from '@/pages/BaseClass';

import $ from 'jquery';
import {
	Button,
	DatePicker,
	Input,
	Form,
	Select,
	Table,
	Modal,
	Descriptions,
	Image,
} from 'antd'
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost,
	parseTime,
	formatTime,
} from '@/utils/Tools';

const {Column,ColumnGroup} = Table;
const {Option} = Select;
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'selectedRowKeys':[],
			
			'orderTypeList':{},
			'reasonList':{},
			'solutionList':{},
			'statusList':{},
			
			'list':[],
			'pageInfo':{
				'current':1,
				'total':0,
				'pageSize':10,
			},
			
			'info':{
				
			},
			'showDialog':false,
		};
	}
	
	componentDidMount()
	{
		document.title = '售后记录 - ' + CommonValue.get('site_name');
		this.getList();
		this.getOrderTypeList();
		this.getSolutionList();
	}
	
	getList(page,pageSize)
	{
		if(!page) page = 1;
		if(!pageSize) pageSize = this.state.pageInfo.pageSize;
		
		let url = pcUrl('orderService','index');
		let param = this._parseFilter(this.filterForm.getFieldsValue());
		param['page'] = page;
		param['page_size'] = pageSize;
		
		httpPost(url,param)
			.then(data=>{
				this.setState({
					'list':data['list'],
					'pageInfo':{
						'current':page,
						'total':data['page_info'].total,
						'pageSize':pageSize,
					},
				});
			});
	}
	
	_parseFilter(filter)
	{
		if(filter.time && filter.time.length)
		{
			filter['start_time'] = moment(filter.time[0]).format('YYYY-MM-DD');
			filter['end_time'] = moment(filter.time[1]).format('YYYY-MM-DD');
			delete(filter.time);
		}
		return filter;
	}
	
	getOrderTypeList()
	{
		let url = pcUrl('order','typeList');
		
		httpPost(url)
			.then(data=>{
				this.setState({
					'orderTypeList':data,
				});
			});
	}
	
	getSolutionList()
	{
		let url = pcUrl('orderService','solutionList');
		
		httpPost(url)
			.then(data=>{
				this.setState({
					'reasonList':data['reason_list'],
					'solutionList':data['solution_list'],
					'statusList':data['status_list'],
				});
			});
	}
	
	add()
	{
		this.props.history.push('/user/orderServiceAdd');
		//window.location.href = ngUrl('user','orderServiceAdd');
	}
	
	show(index)
	{
		let info = this.state.list[index];
		this.setState({
			'info':info,
			'showDialog':true,
		});
	}
	
	export()
	{
		let selection = this.state.selectedRowKeys;
		if(!selection.length)
		{
			if(!+this.state.pageInfo.total)
			{
				message('无可导出数据');
				return false;
			}
			
			confirm('您没有选择要导出的数据，确认导出所有数据吗?')
				.then(()=>{
					let url = pcUrl('orderService','index');
					let param = this._parseFilter(this.filterForm.getFieldsValue());
					param['page_size'] = 0;
					httpPost(url,param)
						.then(data=>{
							this._export(data.list);
						});
				});
		}
		else
		{
			let url = pcUrl('orderService','index');
			let param = {
				'service_ids':this.state.selectedRowKeys.join(','),
			};
			param['page_size'] = 0;
			httpPost(url,param)
				.then(data=>{
					this.setState({
						'selectedRowKeys':[],
					});
					this._export(data.list);
				});
		}
	}
	
	_export(rawData)
	{
		let tableHead = [
			{
				'key':'order_sn',
				'name':'订单编号',
			},
			{
				'key':'order_add_time',
				'name':'下单时间',
			},
			{
				'key':'order_type',
				'name':'产品类型',
			},
			{
				'key':'order_amount',
				'name':'订单金额',
			},
			
			{
				'key':'add_time',
				'name':'申请时间',
			},
			
			{
				'key':'service_reason',
				'name':'售后原因',
			},
			{
				'key':'product_name',
				'name':'产品名称',
			},
			{
				'key':'problem_desc',
				'name':'问题描述',
			},
			{
				'key':'service_solution',
				'name':'解决方案',
			},
			{
				'key':'phone',
				'name':'联系方式',
			},
			{
				'key':'qq',
				'name':'QQ',
			},
			{
				'key':'status',
				'name':'处理进度',
			},
		];
		
		// 新建空workbook，然后加入worksheet
		//组装数据
		let data = [];
		data.push(tableHead.map(row=>row.name));
		
		rawData.forEach((row,index)=>{
			let newRow = [];
			
			tableHead.forEach(row1=>{
				let key = row1.key;
				let name = row1.name;
				let group = row1.group;
				let value = '';
				if(group)
				{
					value = row[group][key];
				}
				else
					value = row[key];
				
				if(
					'order_add_time' == key ||
					'add_time' == key
				)
				{
					value = parseTime(value);
				}
				else if('order_type' == key)
				{
					value = this.state.orderTypeList[value];
				}
				else if('order_amount' == key)
				{
					value = '￥'+value;
				}
				else if('service_reason' == key)
				{
					value = this.state.reasonList[value];
				}
				else if('service_solution' == key)
				{
					value = this.state.solutionList[value];
				}
				else if('status' == key)
				{
					value = this.state.statusList[value];
				}
				
				newRow.push(value);
			});
			data.push(newRow);
		});
		
		const ws = XLSX.utils.aoa_to_sheet(data)
		// 设置每列的列宽，10代表10个字符，注意中文占2个字符
		// 新建book
		const wb = XLSX.utils.book_new()
		// 生成xlsx文件(book,sheet数据,sheet命名)
		XLSX.utils.book_append_sheet(wb, ws, '数据详情')
		// 写文件(book,xlsx文件名称)
		let fileName = '售后记录导出列表'+formatTime('Y_m_d_H_i_s')+'.xlsx';
		XLSX.writeFile(wb, fileName);
		return;
	}
	
	render()
	{
		return (
		<div style={{'padding':'2em'}}>
			<div className="filter">
				<div className="float-right">
					<button className="button button-orange" onClick={()=>this.add()}>
						<span className="fa fa-plus-circle"></span>
						&nbsp;
						申请售后
					</button>
				</div>
				<Form layout="inline" ref={e=>this.filterForm=e} onFinish={(data)=>this.getList()}>
					<Form.Item name="time">
						<DatePicker.RangePicker />
					</Form.Item>
					<Form.Item name="service_reason">
						<Select allowClear={true} style={{'width':'14em'}} placeholder="选择售后原因">
							{Object.keys(this.state.reasonList).map(key=>(
								<Option value={key}>{this.state.reasonList[key]}</Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item name="name">
						<Input allowClear={true} style={{'width':'14em'}} placeholder="请输入产品名或订单号" />
					</Form.Item>
					<Form.Item name="">
						<button className="button button-green">
							<span className="fa fa-search"></span>
							&nbsp;
							搜索
						</button>
					</Form.Item>
				</Form>
			</div>
			<div style={{'margin':'1em 0 1em 0'}}>
				<button className="button button-border" onClick={()=>this.export()}>导出订单</button>
			</div>
			<Table
				rowKey="service_id"
				rowSelection={{
					'selectedRowKeys':this.state.selectedRowKeys,
					'onChange':(selectedRowKeys, selectedRows)=>{window.console.log(selectedRowKeys);this.setState({selectedRowKeys});},
				}}
				pagination={{...this.state.pageInfo,'onChange':(page)=>{this.getList(page);}}} dataSource={this.state.list}>
				<Column title="订单号" dataIndex="order_sn" width={30*5} ellipsis />
				<Column title="下单时间" dataIndex="order_add_time" width={30*4} ellipsis render={(text,row,index)=>parseTime(row['order_add_time'])}/>
				<Column title="产品类型" dataIndex="order_type" width={30*3} ellipsis render={(text,row,index)=>this.state.orderTypeList[row['order_type']]} />
				<Column title="订单金额" dataIndex="order_amount" width={30*3} ellipsis render={(text,row,index)=>'￥'+row['order_amount']} />
				<Column title="申请时间" dataIndex="add_time" width={30*4} ellipsis render={(text,row,index)=>parseTime(row['add_time'])} />
				<Column title="售后原因" dataIndex="service_reason" width={30*4} ellipsis render={(text,row,index)=>this.state.reasonList[row['service_reason']]} />
				<Column title="售后进度" dataIndex="status" width={30*3} ellipsis render={(text,row,index)=>this.state.statusList[row['status']]} />
				<Column title="操作" fixed="right" width={30*3} render={(text,row,index)=>(
					<a href="javascript:;" className="text-blue" onClick={()=>this.show(index)}>查看</a>
				)} />
			</Table>
			<Modal
				title="查看详情"
				width={600}
				visible={this.state.showDialog}
				onCancel={()=>this.setState({'showDialog':false})}
				footer={null}>
				<Descriptions
					bordered
					size="small"
					column={1}>
					<Descriptions.Item label="售后原因">{this.state.reasonList[this.state.info['service_reason']]}</Descriptions.Item>
					<Descriptions.Item label="订单号">{this.state.info['order_sn']}</Descriptions.Item>
					<Descriptions.Item label="产品名称">{this.state.info['product_name']}</Descriptions.Item>
					<Descriptions.Item label="问题描述">{this.state.info['problem_desc']}</Descriptions.Item>
					<Descriptions.Item label="解决方案">{this.state.solutionList[this.state.info['service_solution']]}</Descriptions.Item>
					<Descriptions.Item label="联系方式">{this.state.info['phone']}</Descriptions.Item>
					<Descriptions.Item label="QQ">{this.state.info['qq']}</Descriptions.Item>
					{this.state.info['attachment'] && this.state.info['attachment'].length && (
						<Descriptions.Item label="凭证">
							{this.state.info['attachment'].map((row,index)=>(
								<>
									<Image width={80} preview={{'src':row['image_name']}} src={row['thumb_name']} />
									&nbsp;
								</>
							))}
						</Descriptions.Item>
					)}
					<Descriptions.Item label="处理进度">{this.state.statusList[this.state.info['status']]}</Descriptions.Item>
				</Descriptions>
			</Modal>
		</div>
		);
	}
}

